import React from 'react';
import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';
import TableHead from '@mui/material/TableHead';

// Background only — viewport pinning is handled by sticky-header.js because
// the table lives inside an overflow-x container (required for wide tables).
const StyledTableHead = styled(TableHead)(({ theme }) => {
  return {
    backgroundColor: theme.palette.background.default,
    '& th': {
      backgroundColor: theme.palette.background.default,
    },
  };
});

const StickyTableHead = ({ children }) => {
  return <StyledTableHead>{children}</StyledTableHead>;
};

StickyTableHead.propTypes = {
  children: PropTypes.node,
};

export default StickyTableHead;
